import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { MessageService } from 'primeng';
import { Message } from '../../../classes/Message';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { InboxJobsService } from '../../../services/inbox-jobs.service';
import { JobsService } from '../../../services/job.service';
import { MapService } from '../../../services/map.service';
import { InputHelper } from '../../../utils/input.helper';

import { ITaskInfo } from '../../../interfaces/task-info';
import { OrderService } from '../../../services';
import { IJobScreen } from '../../../interfaces/job/job';
import { SupplierInboxJobsService } from '../../../services';
import { BBWTMessageService } from '../../../services';
import { GoogleAnalyticsService } from '../../../services';
import { JobStatus } from '../../../components/reports/jobs-report.component';
import { UserService } from '../../../services';
import { LogisticActivityEnum } from '../../../interfaces/task-logistic';
import { IAcceptJob } from '../job-list/accept-job-dialog.component';
import moment from 'moment';
import { RejectJobWithReasonDTO } from '../../../interfaces/job-rejection/reject-job-with-reason.dto.interface';
import { JobAnalyticsService } from '../../../services/product-analytics/job-analytics.service';
import { ImpersonationInfo } from 'src/app/interfaces/user';

export const RejectJobReasons = {
  1: 'Unavailable To Work',
  2: 'Taken Another Job',
  3: 'Alert Not Relevant',
  4: 'Public Transport Costs Too High',
  5: 'Other',
};

export enum JobUnavailableReason {
  AlreadyAccepted = 1,
  TakenBySomeoneElse = 2,
  JobStatusWrong = 3,
}

@Component({
  selector: 'job-list-item',
  styleUrls: ['./job-list-item.component.scss'],
  templateUrl: './job-list-item.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class JobListItemComponent implements OnInit {
  private jobId: number;
  public organisationTypeId = 1;
  public jobInfo: IJobScreen;
  public jobToAccept: IAcceptJob;

  public tasks: ITaskInfo[];
  public totalDistance: number;
  public totalDuration: any;
  public rejectJobDialog: boolean = false;
  public acceptJobDialogVisible: boolean = false;
  public organisationId: number;
  public rejectReasons: {}[] = [];
  public rejectReason: number = null;
  public jobAvailable: boolean = true;
  public logisticActivityEnum = LogisticActivityEnum;
  private googleAnalyticsEventCategory: string = 'auto_direct_inbox';

  @Input() googleAnalyticsEventLabel: string;

  jobAcceptResult_Success = 1;
  jobAcceptResult_PreviouslyAccepted = 2;
  jobAcceptResult_TaskTypeRequirementNotMet = 3;
  unavailableReason: number;

  public jobUnavailableReason = JobUnavailableReason;
  isUserImpersonate = false;
  impersonatedUserGUID: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public messageService: MessageService,
    public inputHelper: InputHelper,
    public inboxjobsService: InboxJobsService,
    public mapService: MapService,
    private jobService: JobsService,
    private userService: UserService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private supplierInboxjobsService: SupplierInboxJobsService,
    public BBWTmessageService: BBWTMessageService,
    private orderService: OrderService,
    private jobAnalyticsService: JobAnalyticsService,
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.jobId = params['id'];

      this.getCurrentOrg().then(() => {
        this.loadJob();
      });

      this.loadRejectReasons();
    });

    this.loadOptions();
    this.loadImpersonateInfo();
  }

  loadImpersonateInfo() {
    this.userService.isUserImpersonating().then((res) => {
      var resultData: ImpersonationInfo;
      resultData = res;
      if (resultData != null) {
        this.isUserImpersonate = resultData.isImpersonating;
        this.impersonatedUserGUID = resultData.isImpersonating
          ? resultData.impersonatedUserGUID
          : resultData.originalUserId;
      }
    });
  }

  async getCurrentOrg() {
    this.userService.getCurrentUserOrg().then((res) => {
      if (res) {
        this.organisationTypeId = res.organisationTypeId;
        this.organisationId = res.id;
      }
    });
  }

  stringToDuration(durationString: string) {
    return this.durationFormatMinutes(moment.duration(durationString).asMinutes());
  }

  durationFormatMinutes(duration: number) {
    return (
      moment.duration(duration, 'minutes').hours() +
      ' hr ' +
      moment.duration(duration, 'minutes').minutes() +
      ' min'
    );
  }

  loadJob() {
    this.jobService
      .get(this.jobId)
      .then((res) => {
        this.jobInfo = res;
        this.totalDistance = 0;
        this.tasks = [];
        let tmpDuration = 0;

        this.jobToAccept = {
          id: res.id,
          supplierPrice: res.buyItNowPrice,
        };

        if (this.jobInfo.supplierId != null) {
          this.jobAvailable = false;

          if (this.jobInfo.supplierId == this.organisationId) {
            this.unavailableReason = JobUnavailableReason.AlreadyAccepted;
          } else {
            this.unavailableReason = JobUnavailableReason.TakenBySomeoneElse;
          }
        } else {
          if (this.jobInfo.statusId != JobStatus.Created) {
            this.jobAvailable = false;
            this.unavailableReason = JobUnavailableReason.JobStatusWrong;
          }
        }

        this.jobInfo.orders.forEach((orders) => {
          this.tasks = [...this.tasks, ...orders.tasks];

          orders.tasks.forEach((x) => {
            this.totalDistance += x.distance;

            tmpDuration += moment.duration(x.estimateTime).asMinutes();

            if (x.taskLogistics.length > 0) {
              x.taskTransit = {};

              let byRoad = x.taskLogistics.find(
                (x) =>
                  x.activity == this.logisticActivityEnum.TRANSIT_TO_TASK_BY_ROAD && x.isEstimate,
              );
              let byPublic = x.taskLogistics.find(
                (x) =>
                  x.activity == this.logisticActivityEnum.TRANSIT_TO_TASK_PUBLIC_TRANSPORT &&
                  x.isEstimate,
              );

              if (byRoad != null) {
                x.taskTransit.byPublicTransportDurationMinutes = byPublic.durationMinutes;
                x.taskTransit.byPublicTransportDistanceMiles = byPublic.distanceMiles;

                if (byRoad.distanceMiles > 0) {
                  this.totalDistance += byRoad.distanceMiles;
                }
                if (byRoad.durationMinutes > 0) {
                  tmpDuration += byRoad.durationMinutes;
                }
              }

              if (byPublic) {
                x.taskTransit.byRoadDurationMinutes = byRoad.durationMinutes;
                x.taskTransit.byRoadDistanceMiles = byRoad.distanceMiles;
              }
            }
          });
        });

        this.totalDuration = this.durationFormatMinutes(tmpDuration);
      })
      .catch((err) => {
        console.log(err);

        if (err.error && err.error.Message) {
          this.messageService.add(Message.Error(`${err.error.Message}`, 'Load Job'));
        } else {
          this.messageService.add(Message.Error(`Could not load job`, 'Load Job'));
        }
      });
  }

  public watchJob() {
    this.supplierInboxjobsService.watchJob(this.jobId).then(() => {
      this.BBWTmessageService.ShowSuccess('Watch Job', 'Job is watched');
    });
  }

  private loadOptions() {}

  rejectJob() {
    this.googleAnalyticsService.eventEmitter(
      'reject_job',
      this.googleAnalyticsEventCategory,
      'reject_job',
      this.googleAnalyticsEventLabel,
    );

    const dto = <RejectJobWithReasonDTO>{
      jobId: this.jobId,
      rejectionReasonId: this.rejectReason,
      reasonText: '', // todo
    };
    this.supplierInboxjobsService.rejectJobWithReason(dto).then(() => {
      const registrationNumber = this.jobInfo.orders.reduce((total, order) => {
        const orderRegistrationNumber = order.tasks.reduce(
          (sum, task) => sum + task.vehicle?.registrationNumber,
          '',
        );
        return total + orderRegistrationNumber;
      }, '');
      this.jobAnalyticsService.sendHideJobEvent(
        this.jobInfo.id,
        registrationNumber,
        RejectJobReasons[this.rejectReason],
        '',
      );
      this.rejectJobDialog = false;
    });
  }

  async regenTransit(id: number) {
    await this.orderService.regenTransitTimes(id);
  }

  private loadRejectReasons() {
    Object.keys(RejectJobReasons).forEach((x) => {
      this.rejectReasons.push({ value: x, label: RejectJobReasons[x] });
    });
  }

  viewMoreInfo() {
    this.router.navigate(['app/jobscreen', this.jobId]);
  }
}
